export const FAQ_CONTENT = {
  en: {
    title: "Frequently Asked Questions",
    termsTitle: "Rental Terms & Conditions",
    termsSummary: [
      "1. The security deposit is refundable after the unit is returned and inspected.",
      "2. The customer is responsible for damage or missing items.",
      "3. Please ensure delivery access is available at the scheduled time.",
      "4. Cancellation within 24 hours may be subject to a fee.",
    ],
    termsLink: "Read the full Rental Terms & Conditions",
    items: [
      [
        "How does the portable Mahjong table work?",
        "It is a fully automatic shuffling Mahjong table that folds down and can be set up on any regular table in minutes.",
      ],
      [
        "Do you deliver?",
        "Yes. We deliver and pick up across Jakarta and surrounding areas. Self pickup is also available.",
      ],
      [
        "How much is the deposit?",
        "The standard refundable security deposit is Rp500.000.",
      ],
      [
        "Is the deposit refundable?",
        "Yes, fully refundable after the unit is returned and inspected.",
      ],
      [
        "Do you provide Mahjong tiles?",
        "Yes, a complete set of 144 tiles is included with every rental.",
      ],
      [
        "Can I rent for an event?",
        "Absolutely. We serve communities, cafes, corporate events and tournaments.",
      ],
      [
        "Can I rent for multiple days?",
        "Yes, multi-day packages are available. Contact us for more than 3 days.",
      ],
      [
        "Can I rent more than one table?",
        "Yes, subject to unit availability on your selected date and time.",
      ],
      [
        "What happens if something is damaged?",
        "We inspect on return. Any damage or missing item may be deducted from the deposit.",
      ],
    ],
  },
  id: {
    title: "Pertanyaan yang Sering Diajukan",
    termsTitle: "Syarat & Ketentuan Sewa",
    termsSummary: [
      "1. Deposit keamanan dikembalikan setelah unit dikembalikan dan diperiksa.",
      "2. Pelanggan bertanggung jawab atas kerusakan atau barang yang hilang.",
      "3. Pastikan akses pengiriman tersedia pada waktu yang dijadwalkan.",
      "4. Pembatalan dalam 24 jam dapat dikenakan biaya.",
    ],
    termsLink: "Baca Syarat & Ketentuan Sewa lengkap",
    items: [
      [
        "Bagaimana cara kerja meja Mahjong portabel?",
        "Ini adalah meja Mahjong pengocok otomatis penuh yang dapat dilipat dan dipasang di meja biasa dalam beberapa menit.",
      ],
      [
        "Apakah tersedia layanan pengiriman?",
        "Ya. Kami mengantar dan menjemput di Jakarta serta area sekitarnya. Ambil sendiri juga tersedia.",
      ],
      [
        "Berapa besar depositnya?",
        "Deposit keamanan standar yang dapat dikembalikan adalah Rp500.000.",
      ],
      [
        "Apakah deposit dapat dikembalikan?",
        "Ya, dikembalikan penuh setelah unit dikembalikan dan diperiksa.",
      ],
      [
        "Apakah tile Mahjong disediakan?",
        "Ya, satu set lengkap berisi 144 tile disertakan pada setiap penyewaan.",
      ],
      [
        "Apakah saya dapat menyewa untuk acara?",
        "Tentu. Kami melayani komunitas, kafe, acara perusahaan, dan turnamen.",
      ],
      [
        "Apakah saya dapat menyewa untuk beberapa hari?",
        "Ya, paket beberapa hari tersedia. Hubungi kami untuk durasi lebih dari 3 hari.",
      ],
      [
        "Apakah saya dapat menyewa lebih dari satu meja?",
        "Ya, sesuai ketersediaan unit pada tanggal dan waktu pilihan Anda.",
      ],
      [
        "Bagaimana jika ada yang rusak?",
        "Kami memeriksa unit saat dikembalikan. Kerusakan atau item yang hilang dapat dipotong dari deposit.",
      ],
    ],
  },
};